<template>
  <div>
    <ComHeaderTwo ></ComHeaderTwo>
<!-- @operatePrompt="operate_prompt" -->
    <div class="home">
      <div class="back">
        <div class="home_top">
          <div class="search">
            <h1 style="position: relative; top: -30px">
              司法大数据&thinsp;/&thinsp;查全&thinsp;/&thinsp;查准
            </h1>

            <div style="margin-top: 15px" class="inputSearch">
              <el-input
                placeholder="请输入案号、文书标题、案情描述"
                v-model="input"
                class="input-with-select home_input"
                prefix-icon="el-icon-search"
                clearable
                @keyup.enter.native="search"
              >
                <el-button slot="append" @click="search" style=""
                  >搜索</el-button
                >
              </el-input>
              <div class="semanteme_css" v-if="prompt_img">
                <i
                  class="el-icon-circle-close close_i"
                  @click="prompt_img = !prompt_img"
                ></i>
                <img
                  class=""
                  src="../assets/imgs/semanteme.png"
                  alt=""
                  @click="centerDialogVisible = !centerDialogVisible"
                />
              </div>
            </div>
            <h2 class="describe_txt">
              案情描述：为了更加高效地进行语义类案检索，您可以输入具体的案情描述，描
              述内容请尽量详细
            </h2>
          </div>
          <div class="banner_img">
            <img
              style="width: 650px"
              src="../assets/imgs/2.0/人像-1.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="home_bottom">
        <div class="synopsis">
          <h2>平台简介</h2>
          <div class="synopsis_box">
            <div class="synopsis_left">
              <h3>Platform profile</h3>
              <p>
                "哲思司法大数据平台"是以大数据技术为支撑的司法关联数据深度挖掘与聚类分析平台。该平台利用可视化大数据分析技术，提高了研究对象的整体描述能力。提供了以案例、法规为核心的司法关联数据的整合挖掘与分析应用。
              </p>
              <p>
                该平台覆盖立案信息、开庭公告、法院公告送达公告、破产程序、司法拍卖、司法冻结、被执行人、失信被执行人、限制高消费、终本案件、裁判文书等多种类型；实现T+0实时更新；支持AI自动生成可视化图表，具备数据分析与统计功能；提供个性化服务定制，API接口调用数据；为法律研究者与司法从业工作者提供全面的数据支撑，是专业人员不可获缺的重要工具。
              </p>
            </div>
            <div class="synopsis_right">
              <div class="imgs">
                <div class="img_left">
                  <img
                    style="width: 200px; height: 300px"
                    src="../../src/assets/imgs/素材/001企业微信截图.png"
                    alt=""
                  />
                  <div
                    style="
                      width: 80px;
                      height: 80px;
                      background: #ff8d1a;
                      margin: 10px 0 0 120px;
                    "
                  ></div>
                </div>
                <div class="img_right" style="width: 200px; margin: 0 0 0 20px">
                  <img
                    style="width: 200px; height: 200px"
                    src="../../src/assets/imgs/素材/pexels-ekaterina-bolovtsova-6077326.jpg.png"
                    alt=""
                  />
                  <img
                    style="width: 200px; height: 200px; margin: 20px 0 0 0px"
                    src="../../src/assets/imgs/素材/002企业微信截图.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="serve">
        <div class="advantage">
          <h2>平台优势</h2>
          <h3>Platform advantages</h3>
          <div class="advantages">
            <div class="superiority">
              <img
                src="../assets/imgs/素材/286b13832002c888ad17d17e6893817.png"
                alt=""
              />
              <p class="words">专业海量资源</p>
            </div>
            <div class="superiority">
              <img
                src="../assets/imgs/素材/b4c89cfbffebbae8cd1433d462dfb06.png"
                alt=""
              />
              <p class="words">T+0实时更新</p>
            </div>
            <div class="superiority">
              <img
                src="../assets/imgs/素材/c0d46d9fdb6d831842cfb56a229d77a.png"
                alt=""
              />
              <p class="words">多维检索过滤</p>
            </div>
            <div class="superiority">
              <img
                src="../assets/imgs/素材/b999f9198c388f2fb482cbfe25d317a.png"
                alt=""
              />
              <p class="words">AI可视化报告</p>
            </div>
          </div>
        </div>
      </div>
      <div class="serve" style="background: #ffffff">
        <div class="advantage">
          <h2>平台数据</h2>
          <h3>Platform data</h3>
          <div class="advantages_card">
            <div :class="'dataSum'">
              <img src="../assets/imgs/“平台数据”图标/新增入库.png" alt="" />
              <div>
                <p>
                  今日新增<br />
                  <span style="font-weight: 600; margin-right: 10px">{{
                    new_nums
                  }}</span
                  >篇
                </p>
              </div>
            </div>
            <div :class="'dataSum'">
              <img src="../assets/imgs/哲思首页配图/所有招标项目.png" alt="" />
              <div>
                <p>
                  文书总量<br />
                  <span style="font-weight: 600; margin-right: 10px">{{
                    all
                  }}</span
                  >篇
                </p>
              </div>
            </div>

            <div :class="'dataSum'">
              <img src="../assets/imgs/“平台数据”图标/其他.png" alt="" />
              <div>
                <p>
                  法律法规<br />
                  <span style="font-weight: 600; margin-right: 10px">{{
                    flfg
                  }}</span
                  >篇
                </p>
              </div>
            </div>
            <div :class="'dataSum'">
              <img src="../assets/imgs/“平台数据”图标/民事.png" alt="" />
              <div>
                <p>
                  民事案由<br />
                  <span style="font-weight: 600; margin-right: 10px">{{
                    msay
                  }}</span
                  >篇
                </p>
              </div>
            </div>
            <div :class="'dataSum'">
              <img src="../assets/imgs/“平台数据”图标/刑事.png" alt="" />
              <div>
                <p>
                  刑事案由<br />
                  <span style="font-weight: 600; margin-right: 10px">{{
                    xsay
                  }}</span
                  >篇
                </p>
              </div>
            </div>
            <div :class="'dataSum'">
              <img src="../assets/imgs/“平台数据”图标/执行.png" alt="" />
              <div>
                <p>
                  执行案由<br />
                  <span style="font-weight: 600; margin-right: 10px">{{
                    zxay
                  }}</span
                  >篇
                </p>
              </div>
            </div>
            <div :class="'dataSum'">
              <img src="../assets/imgs/“平台数据”图标/赔偿.png" alt="" />
              <div>
                <p>
                  国家赔偿案由<br />
                  <span style="font-weight: 600; margin-right: 10px">{{
                    gjpcay
                  }}</span
                  >篇
                </p>
              </div>
            </div>
            <div :class="'dataSum'">
              <img src="../assets/imgs/“平台数据”图标/行政.png" alt="" />
              <div>
                <p>
                  行政案由<br />
                  <span style="font-weight: 600; margin-right: 10px">{{
                    xzay
                  }}</span
                  >篇
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overview">
        <div class="serves">
          <h2>服务范围</h2>
          <h3>Scope of service</h3>
          <div class="serve_imgs">
            <div v-for="(item, index) in imgs" :key="index">
              <img style="width: 180px" :src="item.image" alt="" ref="aaa" />

              <div class="tit">
                <span> {{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ComFooter></ComFooter>

    <el-dialog
      title="语义检索"
      :visible.sync="centerDialogVisible"
      :width="'650px'"
      center
      class="dialog_"
    >
      <h2 class="css_h">
        利用自然语言理解、语义相似性分析等多种人工智能AI技术，基于对案件事实内容的深度理解，
      </h2>
      <h2 class="css_h">
        语义类案检索可实现用户检索意图自动判别分析，引领法学工作者精准定位类案信息
      </h2>
      <p class="css_tit">1、请输入完整的案情描述</p>
      <p class="css_txt">
        如：未取得机动车驾驶资格，醉酒后驾驶未在GAJG登记的爱玛牌电动二轮摩托车，由南向北行驶至海城市站前大市场门前路段时，与由东向西王烈驾驶的辽Ｃ07××**号中通牌大型通客车发生剐蹭，造成车辆损坏。经海城市正骨医院法医司法鉴定所鉴定：送检的王永宇血液中检出酒精成分，其含量136mg/100ml。
      </p>
      <!-- <p class="css_tit">2、案情描述不少于50字</p> -->
      <!-- <p class="css_tit">3、输入格式为？？+ 案情描述</p> -->
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" round @click="centerDialogVisible = false"
          >知 道 了</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ComHeader from "../components/ComHeader.vue";
import ComHeaderOne from "../components/ComHeaderOne.vue";
import ComHeaderTwo from "../components/ComHeaderTwo.vue";
import ComFooter from "../components/ComFooter.vue";

import store from "@/store";
export default {
  name: "Home",
  data() {
    return {
      centerDialogVisible: false,
      input: "",
      params: {},
      condition: [], //条件列表
      pick: true,
      type: [
        {
          paperwork: "裁判文书",
          number: "130,232,476",
        },
        {
          paperwork: "法律法规",
          number: "130,232,476",
        },
        {
          paperwork: "民事案由",
          number: "130,232,476",
        },
        {
          paperwork: "刑事案由",
          number: "130,232,476",
        },
        {
          paperwork: "执行案由",
          number: "130,232,476",
        },
        {
          paperwork: "国家赔偿案由",
          number: "130,232,476",
        },
        {
          paperwork: "行政案由",
          number: "130,232,476",
        },
      ],
      all: "",
      new_nums: "",
      zxay: "",
      flfg: "",
      xsay: "",
      msay: "",
      xzay: "",
      gjpcay: "",
      ws: "",
      searchInput: [],
      imgs: [
        { name: "研究院", image: require("../assets/imgs/素材/蒙版分组7.png") },
        {
          name: "律 所",
          image: require("../assets/imgs/素材/蒙版分组 (1).png"),
        },
        {
          name: "企 业",
          image: require("../assets/imgs/素材/蒙版分组 (2).png"),
        },
        {
          name: "高 校",
          image: require("../assets/imgs/素材/蒙版分组 (3).png"),
        },
        {
          name: "个 人",
          image: require("../assets/imgs/素材/蒙版分组 (4).png"),
        },
      ],
      seen: false,
      current: null,
      prompt_img: true,
      state_: false,
    };
  },
  components: {
    ComHeader,
    ComFooter,
    ComHeaderOne,
    ComHeaderTwo,
  },

  created() {
    this.dataStats();

    if (window.localStorage.getItem("operate_prompt")) {
      this.centerDialogVisible = true;
      setTimeout(() => {
        window.localStorage.removeItem("operate_prompt");
      }, 3000);
    }
  },
  watch: {
    state_: {
      // handler: function (newName, oldName) {
      //   console.log(newName, oldName);
      // },
      // immediate: true,
    },
  },
  methods: {
    // operate_prompt(val) {
    //   if (val) {
    //     this.state_ = val;
    //     // console.log(this.state_);
    //   }
    // },
    search() {
      this.searchInput = [];
      if (store.getCookie("token_S")) {
        if (this.input !== "") {
          var inputObj = [
              ["case_description", [["and", this.input, "2"]]],
            ];
          // if (this.input.length >= 50) {
          //   var inputObj = [
          //     ["case_description", [["and", this.input, "2"]]],
          //   ];
          //   // if (this.input.length < 52) {
          //   //   this.$message({
          //   //     message: "案情描述不能不小于50字!请补充描述",
          //   //     type: "warning",
          //   //   });
          //   //   return;
          //   // }
          // } else {
          //   this.searchInput.push(this.input);
          //   let a =
          //     /\d{4}〕.*?号之[一|二|三|四|五|六|七|八|九|十]$|〔\d{4}〕.*?号$|\（\d{4}\）.*?号之[一|二|三|四|五|六|七|八|九|十]$|\(\d{4}\).*?号之[一|二|三|四|五|六|七|八|九|十]$|\（\d{4}\）.*?号之.*?[一|二|三|四|五|六|七|八|九|十]$|\(\d{4}\).*?号之.*?[一|二|三|四|五|六|七|八|九|十]$|\(\d{4}\).*?号$|\（\d{4}\）.*?号$|(\[d{4}\]).*?号$/;
          //   if (a.test(this.searchInput)) {
          //     var inputObj = [["CaseId", [["and", this.input, "2"]]]];
          //   } else {
          //     var inputObj = [["Casename", [["and", this.input, "2"]]]];
          //   }
          // }

          window.localStorage.setItem("search_new", JSON.stringify(inputObj));
          window.localStorage.setItem("searchType", "2");

          this.$router.push({
            name: "Case",
          });
        } else {
          this.$message.error("请输入检索内容！！");
        }
      }
      if (!store.getCookie("token_S")) {
        this.$message.error("请先登录");
      }
    },
    tap(type) {
      if (type == "new") {
        if (this.pick == true) {
          this.pick = false;
          console.log("a");
        }
      }
      if (type == "sum") {
        if (this.pick == false) {
          this.pick = true;
        }
      }
    },
    dataStats() {
      this.$http
        .get("/statistics", {})
        .then((res) => {
          // console.log(res);
          let number = res.data.data;
          this.all = number.first.all
            .toString()
            .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          this.new_nums = number.first.new_nums
            .toString()
            .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          this.zxay = number.second.zxay
            .toString()
            .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          this.xsay = number.second.xsay
            .toString()
            .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          this.msay = number.second.msay
            .toString()
            .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          this.xzay = number.second.xzay
            .toString()
            .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          this.gjpcay = number.second.gjpcay
            .toString()
            .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          this.ws = number.second.ws
            .toString()
            .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          this.flfg = number.second.flfg
            .toString()
            .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        })
        .catch((error) => {});
    },
    inFun(i) {
      this.$refs.aaa[i].style.transform = "scale(1.2,1.2)";
      this.$refs.aaa[i].style.transition = "0.3s";

      this.$refs.bbb[i].style.transform = "scale(1.2,1.2)";
      this.$refs.bbb[i].style.transition = "0.3s";
      let that = this;
      setTimeout(function () {
        that.$refs.bbb[i].style.display = "block";
      }, 500);
    },
    outFun(i) {
      this.$refs.aaa[i].style.transform = "scale(1,1)";
      this.$refs.bbb[i].style.transform = "scale(1,1)";
      let that = this;
      setTimeout(function () {
        that.$refs.bbb[i].style.display = "none";
      }, 500);
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  max-height: 2700px !important;

  background: #fbf3eb;
  // min-width: 1920px;
  // max-width: 2500px;
  // min-height: 500px;
  // min-width: 1800px;
  min-width: 1280px;
  margin: auto;
  .back {
    // background: #ff7803;
    background: url("../assets/imgs/底板.jpg");
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .home_top {
    height: 380px;

    width: 90%;
    // max-height: 400px;
    // width: 100%;

    // max-width: 1920px;
    max-width: 1350px;
    // min-height: 400px;
    // max-width: 2500px;
    // position: relative;
    // margin: auto;

    // background: url("../assets/imgs/homebackground.png");
    // background: url("../assets/imgs/亮点图标/banner.jpg");
    // background-size: 100% 100%;
    background-size: cover;
    // background-size: 100%;
    // padding-bottom: 57px;
    display: flex;
    justify-content: space-between;
    .search {
      // width: 1650px;
      // width: 1350px;
      // width: 100%;
      // max-width: 1920px;
      // margin: auto;
      padding-top: 120px;
      width: calc(100% - 650px);
      // padding-left: 20px;

      // position: absolute;
      // top: 0px;

      h1 {
        display: inline-block;
        // width: 500px;
        font-family: "庞门正道标题";
        display: inline-block;
        font-size: 58px;
        color: white;
        min-width: 590px;
        // margin: 7% 10% 0% 10%;
        // margin-bottom: 20px;
      }
      .inputSearch {
        width: 450px;
        // height: 90px;
        // margin: 0 10%;
        // padding-bottom: 57px;
        position: relative;
        .semanteme_css {
          height: 120px;
          position: absolute;
          left: -170px;
          top: -40px;
          cursor: pointer;
          img {
            width: 150px;
          }
          .close_i {
            position: absolute;
            top: 30px;
            right: -8px;
            font-size: 18px;
            color: #f3e5da;
          }
          .close_i:hover {
            color: #f2ff3f;
          }
        }
        /deep/ .el-input__inner {
          height: 70px;
          line-height: 70px;
          padding: 0 50px;
          width: 440px;
          font-size: 21px;
          border: none;
        }
        /deep/ .el-input__prefix {
          font-size: 21px;
          padding: 0 10px;
          position: absolute;
          top: 2px;
        }
        /deep/ .el-input__suffix {
          position: absolute;
          top: 2px;
          i {
            font-size: 21px !important;
          }
        }
        /deep/ .el-input-group__append {
          width: 120px;
          border: 5px rgb(255, 255, 255) solid;
          // border-radius: 5px;
          .el-button {
            width: 150px;
            // height: 38px;
            height: 70px;
            margin: 0;
            padding: 5px 0;
            border: 5px rgb(255, 255, 255) solid;
            background: #ed6b2d;
            border-radius: 10px;
            span {
              font-size: 25px;
            }
          }
          font-size: 28px;
          // height: 60px;
          padding: 0;

          color: white;
          border: none;
        }
      }
      .describe_txt {
        margin: 10px 0;
        width: 600px;
        line-height: 25px;
        color: white;
        // white-space: nowrap;
      }
    }
    .banner_img {
      position: relative;
      top: -125px;
      z-index: 1;
    }
  }
  .figures,
  .overview {
    width: 1050px;
    margin: auto;
  }
  .home_bottom,
  .serve,
  .figures,
  .figures_card,
  .overview {
    .title {
      padding: 32px 0 10px 0;
      h2 {
        text-align: center;
        font-size: 30px;
        margin-bottom: 15px;
      }
      hr {
        width: 36px;
        border-top: 1px solid #ed6c2e;
        // color: #ed6c2e;
      }
      h5 {
        text-align: center;
        font-size: 18px;
        margin: 10px 0;
        color: #e0d8d3;
      }
    }
  }
  .home_bottom {
    // height: 307px;
    // background: #fbf3eb;
    // width: 1650px;
    // width: 1350px;
    // min-width: 1350px;
    // max-width: 1350px;
    background: #ffffff;
    padding: 50px 0;
    width: 100%;
    // max-width: 1920px;
    // margin: auto;
    // padding: 0 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    .synopsis {
      width: 90%;
      max-width: 1350px;
      font-family: "PingFangSC-Regular";
      h2 {
        font-size: 32px;
        font-weight: 700;
        // font-family: 'PingFangSC-Regular';
      }
      .synopsis_box {
        display: flex;
        justify-content: space-between;
        .synopsis_left {
          margin: 0 50px;
          h3 {
            font-size: 23px;
            font-weight: 600;
            line-height: 60px;
            margin-bottom: 30px;
          }
          p {
            text-indent: 2em;
            width: 480px;
            line-height: 30px;
            font-size: 16px;
            margin: 20px 0;
          }
        }
        .synopsis_right {
          padding-right: 100px;
          .imgs {
            display: flex;
          }
        }
      }
    }
  }
  .serve {
    background: #f2f2f2;
    padding: 50px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // background-image: url("../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
    // background-size: 100% 200%;
    // background-repeat: no-repeat;
    .advantage {
      width: 90%;
      max-width: 1350px;

      h2 {
        font-size: 32px;
        font-weight: 700;
        font-family: "微软雅黑";
        // font-family: 'PingFangSC-Regular';
      }
      h3 {
        font-size: 23px;
        font-weight: 600;
        line-height: 60px;
        margin-bottom: 30px;
        margin: 0 50px;
        font-family: "微软雅黑";
        // font-family: 'PingFangSC-Regular';
      }
      .advantages {
        margin: 20px 0;
        // padding-right: 100px;
        display: flex;
        justify-content: space-around;
        font-family: "微软雅黑";
        .superiority {
          // width: 130px;
          .ordinal {
            font-size: 21px;
            font-weight: 500;
            span {
              display: inline-block;
              background: #ff8d1a;
              width: 6px;
              height: 6px;
              border-radius: 3px;
              margin: 0 3px;
            }
          }
          img {
            //  display: block;
            width: 60%;
            margin: 15% 20%;
          }
          .words {
            font-size: 18px;
            font-weight: 600;
            text-align: center;
          }
        }
      }
      .advantages_card {
        min-width: 1200px;
        margin: auto;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
      }
    }
  }
  .figures {
    background: #ffffff;
    padding: 50px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .fig {
      width: 90%;
      max-width: 1350px;
      display: flex;
      justify-content: space-around;
      .fig_left {
        display: flex;
        justify-content: center;
        align-items: center;
        .new {
          width: 200px;
          margin-top: 130px;
          .new_add {
            width: 140px;
            position: relative;
            left: 100px;
            top: -50px;
            padding: 0px 20px;
            background: #ff8d1a;
            img {
              width: 20px;
              position: relative;
              top: -10px;
              left: -28px;
            }
            .txt {
              position: relative;
              top: -10px;
              p {
                //  display: block;
                // position: relative;
                // top: -10px;
                // display: inline-block;
                width: 100%;
                line-height: 30px;
                text-align: center;
                font-size: 18px;
                font-weight: 700;
                // font-family: "微软雅黑";
                color: #ffffff;
              }
            }
          }
        }
      }
      .fig_right {
        h2 {
          font-size: 32px;
          font-weight: 700;
          font-family: "微软雅黑";
          // font-family: 'PingFangSC-Regular';
        }
        h3 {
          font-size: 23px;
          font-weight: 600;
          line-height: 60px;
          margin-bottom: 30px;
          margin: 0 50px;
          font-family: "微软雅黑";
          // font-family: 'PingFangSC-Regular';
        }
        .figures_data {
          margin: 20px 100px 20px 0;
          width: 680px;
          display: flex;
          flex-wrap: wrap;
          .data_fig {
            padding: 20px;
            width: 170px;
            .data_title {
              margin: 0 0 10px 0;
              img {
                width: 24px;
                position: relative;
                top: 6px;
              }
              span {
                margin: 0 5px;
                display: inline-block;
                line-height: 30px;
                font-size: 16px;
              }
            }
            .data_number {
              // margin: 0 0 0 20px;
              width: 100%;
              text-align: right;
              span {
                color: #ff8d1a;
              }
            }
          }
        }
      }
    }
  }
  .figures_card {
    .dataOver {
      div {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        .chosen {
          cursor: pointer;
          margin: 10px;
          padding: 20px 20px;
          width: 230px;
          height: 90px;
          border-radius: 5px;
          display: flex;
          justify-content: flex-start;
          background: #fe7d21;
          img {
            width: 50px;
            height: 50px;
            margin-right: 10px;
          }
          p {
            width: 100%;
            line-height: 25px;
            display: inline-block;
            font-size: 16px;
            color: white;
          }
        }

        .types {
          div {
            background: #f0e9e1;
            margin: 10px;
            padding: 10px 20px;
            width: 200px;
            height: 90px;
            border-radius: 5px;
            display: flex;
            justify-content: flex-start !important;
            align-items: center;
            // justify-content: center;
            p {
              // height: 60px;
              width: 100%;
              line-height: 25px;
              display: inline-block;
              font-size: 16px;
            }
          }
        }
      }
    }
  }

  .overview {
    background: #f2f2f2;
    padding: 50px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .serves {
      width: 90%;
      max-width: 1350px;

      h2 {
        font-size: 32px;
        font-weight: 700;
        font-family: "微软雅黑";
        // font-family: 'PingFangSC-Regular';
      }
      h3 {
        font-size: 23px;
        font-weight: 600;
        line-height: 60px;
        margin-bottom: 30px;
        margin: 0 50px;
        font-family: "微软雅黑";
        // font-family: 'PingFangSC-Regular';
      }
      .serve_imgs {
        display: flex;
        justify-content: space-around;
        // padding-right: 50px;
        height: 280px;
        margin: 20px 0;
        img {
          width: 180px;
          height: 272px;
        }
        .tit {
          width: 180px;
          z-index: 100;
          // text-align: center;
          color: #ffffff;
          font-size: 18px;
          line-height: 50px;
          background: rgba(101, 101, 101, 0.6);
          position: relative;
          top: -52px;
          span {
            display: inline-block;
            margin: 0 25%;
            width: 50%;
            border-right: #ff8d1a 5px solid;
          }
        }
      }
    }
  }
  .background {
    height: 300px;
    .bag {
      height: 500px;
      position: relative;
      top: -200px;
      background-image: url("../assets/imgs/哲思首页配图/山川.png");
      background-size: cover;
    }
  }
}
.dataSum {
  cursor: pointer;
  margin: 10px;
  padding: 20px 20px;
  width: 270px;
  height: 90px;
  border-radius: 5px;
  display: flex;
  justify-content: flex-start;
  // background: #fe7d21;
  border: 2px solid #fe7d21;
  img {
    width: 50px;
    height: 50px;
    margin: 0 20px 0 10px;
  }
  p {
    width: 100%;
    line-height: 25px;
    display: inline-block;
    font-size: 16px;
    color: #fe7d21;
  }
}
.ces {
  display: flex;
  justify-content: space-around;
  position: relative;
  bottom: -80px;
  .ce {
    p {
      padding: 10px 0;
      font-size: 28px;
      font-family: "STXihei";
    }
    span {
      font-size: 20px;
    }
  }
}
.home_input:hover {
  // /deep/ .el-input__inner:focus {
  //设置阴影属性
  // box-shadow: 0px 0px 12px 0px rgba(238, 152, 24, 0.6);
  //设置border属性
  // border: 1px solid #b7a974;
  // }
}
.dataOver {
  .triangle {
    // width: 8;
    // height: 0;
    // border-bottom: 20px solid red;
    // border-top: 20px solid transparent;
    // border-left: 20px solid transparent;
    // border-right: 20px solid transparent;
  }
  .types01 {
    background-color: snow;
    // width: 200px;
    // height: 100px;
    position: relative;
    // border: 1px solid red;
  }

  .types01::before {
    box-sizing: content-box;
    position: absolute;
    top: -18px;
    left: 531px;
    border-bottom: 9px solid snow;
    border-top: 9px solid transparent;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    display: block;
    content: "";
    z-index: 2;
  }
  .types01::after {
    box-sizing: content-box;
    position: absolute;
    top: -20px;
    left: 530px;
    border-bottom: 10px solid red;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    display: block;
    content: "";
    z-index: 1;
  }
  .types02 {
    background-color: snow;
    // width: 200px;
    // height: 100px;
    position: relative;
    // border: 1px solid red;
  }

  .types02::before {
    box-sizing: content-box;
    position: absolute;
    top: -18px;
    left: 771px;
    border-bottom: 9px solid snow;
    border-top: 9px solid transparent;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    display: block;
    content: "";
    z-index: 2;
  }
  .types02::after {
    box-sizing: content-box;
    position: absolute;
    top: -20px;
    left: 770px;
    border-bottom: 10px solid red;
    border-top: 10px solid transparent;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    display: block;
    content: "";
    z-index: 1;
  }
  div {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .chosen {
      cursor: pointer;
      margin: 10px;
      padding: 20px 20px;
      width: 230px;
      height: 90px;
      border-radius: 5px;
      display: flex;
      justify-content: flex-start;
      background: #fe7d21;
      img {
        width: 50px;
        height: 50px;
        margin-right: 10px;
      }
      p {
        width: 100%;
        line-height: 25px;
        display: inline-block;
        font-size: 16px;
        color: white;
      }
    }
    .dataSum {
      cursor: pointer;
      margin: 10px;
      padding: 20px 20px;
      width: 230px;
      height: 90px;
      border-radius: 5px;
      display: flex;
      justify-content: flex-start;
      // background: #fe7d21;
      border: 2px solid #fe7d21;
      img {
        width: 50px;
        height: 50px;
        margin-right: 10px;
      }
      p {
        width: 100%;
        line-height: 25px;
        display: inline-block;
        font-size: 16px;
        color: #fe7d21;
      }
    }
    .types {
      display: flex;
      justify-content: space-around;
      border-radius: 5px;
      border: 1px solid #fe7d21;
      // padding: 0px 0px;
      div {
        // background: #f0e9e1;
        // border: 1px solid #fe7d21;
        margin: 10px;
        padding: 10px 10px;
        width: 200px;
        height: 90px;
        border-radius: 5px;
        display: flex;
        // justify-content: space-around;
        align-items: center;
        img {
          margin-right: 10px;
        }
        // justify-content: center;
        p {
          // height: 60px;
          // width: 100%;
          line-height: 25px;
          display: inline-block;
          font-size: 16px;
        }
        img {
          width: 50px;
        }
      }
    }
  }
}
.dialog_ {
  /deep/ .el-dialog {
    border-radius: 30px;
  }
  /deep/ .el-dialog__title {
    font-weight: 600;
  }
  /deep/ .el-dialog__body {
    padding: 0px 30px;
  }
  .css_h {
    text-align: center;
    line-height: 30px;
    color: #292929;
  }
  .css_tit {
    margin: 10px 0 0 0;
    line-height: 30px;
    color: #292929;
  }
  .css_txt {
    margin: 5px 0 10px 0;
    line-height: 20px;
    color: #acacac;
  }
}
</style>
<style>
.unified {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
}
/* .el-icon-circle-close {
  z-index: 1001;
  font-size: 25px !important;
  position: absolute;
  top: 250px;
  left: 62%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
#T_login {
  width: 500px;
  position: absolute;
  top: 120px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 1000;
} */
.or_ {
  display: inline-block;
  margin: 0 0 0px 5px;
}
</style>
